import { MatchStatus } from "types/entities/Match";

import React from "react";
import { EyeInvisibleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useMessage } from "hooks/useMessage";
import { useTranslations } from "translations/useTranslations";

import { useMatchingContext } from "modules/MatchingModule/MatchingModule.context";

export const MatchingIgnoreButton = React.memo(() => {
  const translations = useTranslations();
  const { showSuccess } = useMessage();

  const { patchSelectedGroups } = useMatchingContext();

  const handleClick = React.useCallback(async () => {
    await patchSelectedGroups({ status: MatchStatus.IGNORED });
    showSuccess(translations["matching.messages.ignore.success"]);
  }, [patchSelectedGroups, showSuccess, translations]);

  return (
    <Button size="small" icon={<EyeInvisibleOutlined />} onClick={handleClick} danger>{translations["matching.buttons.ignore"]}</Button>
  );
});
